import PageTitle from "components/PageTitle";

const Header = () => <PageTitle title="Eagle Beaver Sports Network Users" />;

export default Header;
